{
    "monster": {
        "key": "monster",
        "jobKey": "book/demon",
        "position": {
            "x": 10,
            "y": 4,
            "z": 1
        },
        "previousMultiselect": [
            "monster",
            "54Ft8",
            "ashe",
            "RvIaF"
        ]
    },
    "54Ft8": {
        "position": {
            "x": 8,
            "y": 5,
            "z": 1
        },
        "templateKey": "jobs/ember/torch",
        "jobKey": "book/terrain",
        "key": "54Ft8",
        "previousMultiselect": [
            "monster",
            "54Ft8",
            "ashe",
            "RvIaF"
        ]
    },
    "ashe": {
        "position": {
            "x": 7,
            "y": 6,
            "z": 1
        },
        "templateKey": "player/book/ashe",
        "key": "ashe",
        "previousMultiselect": [
            "monster",
            "54Ft8",
            "ashe",
            "RvIaF"
        ]
    },
    "RvIaF": {
        "position": {
            "x": 9,
            "y": 7,
            "z": 1
        },
        "templateKey": "jobs/ember/torch",
        "jobKey": "book/terrain",
        "key": "RvIaF",
        "previousMultiselect": [
            "monster",
            "54Ft8",
            "ashe",
            "RvIaF"
        ]
    }
}